export const TextFieldValidator = {
  EMAIL: /[^\w\s]/gi,
  NO_SPECIAL_CHAR: /[^\w\s]/gi,
  PHONE: /^[+{1}][0-9]+$/i,
  NUMBER_ONLY: /^[0-9]*$/,
  SPECIAL_CHAR_ONLY: /[^\w\s]/gi,
  ALPHABETS: /^[A-Za-z]*$/,
  ALPHANUMERIC_WITH_SPECIAL_CHARS: /^[\w_@#\-'.\s%&+]*$/,
  NUMBER_WITH_DECIMAL: /^\d+\.?\d*$/,
  TIME_VALIDATOR: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
  DATE_VALIDATOR: /[^a-zA-Z0-9\s:]/g,
  NUMBER_TWO_DECIMAL: /^\d*\.?\d{0,2}$/,
  ALPHANUMERIC: /^[A-Za-z0-9]*$/,
  NUMBER_WITH_DECIMALS_AND_NEGATIVE: /^-?\d{0,10}(\.\d{0,2})?$/,
  ALPHANUMERIC_WITH_CHINESE: /^[a-zA-Z0-9\u4e00-\u9fa5\s]*$/,
  ALPHANUMERIC_WITH_CHINESE_AND_SPECIAL:
    /^[a-zA-Z0-9\u4e00-\u9fa5\s_@#\-'.\%&+]*$/,
};
